module.exports = __webpack_public_path__ + "static/media/goods11.1e726a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/goods11.png
// module id = 217
// module chunks = 0